export default __webpack_public_path__ + "static/create-invoice-7e499391787face5893d0459f691478a.jpg";